// ListingTable.jsx (New File)
import React, { useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  formatDateTimeView,
  formatDateType,
} from "../../../commons/FormatDate"; // Assuming path is correct
import ViewInjectDrawal from "../../Modals/ConGen/ViewInjectDrawal/ViewInjectDrawal";
import { SuccessMessage } from "../../../commons/Toast/ErrorMessage";
import {
  downloadListingSuperAdmin,
  getDocumentRaSuperAdmin,
} from "../../../Services/GNA/AlterApi";
import { getRequistionAdminConsumerRaListing } from "../../../Services/GNA/GetData";

const ListingTable = ({ type, data, setListingView }) => {
  const [viewType, setViewType] = useState({
    status: false,
    data: null,
  });

  const handleGetReq = async ({ ele, id, bidStage, consumerId }) => {
    let res = await getRequistionAdminConsumerRaListing({
      id: id,
      bidStage: bidStage,
      consumerId: consumerId,
    });
    if (res?.data?.code === 200) {
      setViewType({ status: true, data: { ...ele, slots: res?.data?.data } });
    }
  };

  if (!data || data.length === 0) {
    return <div className="pending">No Listing(s)/Tender(s)</div>;
  }

  // Define headers and rendering based on type
  let headers;
  let renderRow;

  if (type === "bilateral") {
    headers = [
      { label: "Listing Number", width: "20%" },
      { label: "Requisition", width: "15%" },
      { label: "Listing Exp. Date & Time", width: "20%" },
      { label: "Terms Exp. Date & Time", width: "20%" },
      { label: "Status", width: "10%" },
      { label: "Download", width: "5%" },
      { label: "Details", width: "5%" },
    ];
    renderRow = (ele) => (
      <>
        <div style={{ width: "20%" }}>{ele?.name}</div>
        <div
          style={{
            width: "15%",
            cursor: "pointer",
            color: "#f1935c",
          }}
          onClick={() =>
            setViewType({
              status: true,
              data: ele,
            })
          }
        >
          View
        </div>
        <div style={{ width: "20%" }}>
          {formatDateType(ele?.listingExpDate)}: {ele?.listingExpTime}
        </div>
        <div style={{ width: "20%" }}>
          {formatDateType(ele?.termsExpDate)}: {ele?.termsExpTime}
        </div>
        <div style={{ width: "10%" }}>
          {ele?.status === "TERMS_ACCEPTED" ? "TERMS" : ele?.status}
        </div>
      </>
    );
  } else if (type === "ra" || type === "rfq") {
    headers = [
      { label: "Tender Number", width: "15%" },
      ...(type === "ra" ? [{ label: "Auction Number", width: "15%" }] : []),
      { label: "Requisition", width: "10%" },
      { label: "Tender Duration", width: "25%" },
      { label: "Tender Type", width: "10%" },
      { label: "Status", width: "10%" },
      { label: "Download", width: "5%" },
      { label: "Details", width: "5%" },
    ];
    renderRow = (ele) => (
      <>
        <div style={{ width: "15%" }}>{ele?.tenderNumber}</div>
        {type === "ra" && (
          <div style={{ width: "15%" }}>{ele?.auctionNumber}</div>
        )}
        <div
          style={{
            width: "10%",
            cursor: "pointer",
            color: "#f1935c",
          }}
          onClick={() =>
            handleGetReq({
              ele: ele,
              id: ele?.id,
              consumerId: ele?.consumerId,
              bidStage: "AUCTION",
            })
          }
        >
          View
        </div>
        <div style={{ width: "25%" }}>
          {formatDateTimeView(ele?.tenderStartDateTime)} to{" "}
          {formatDateTimeView(ele?.tenderCloseDateTime)}
        </div>
        <div style={{ width: "10%" }}>{ele?.auctionType}</div>
        <div style={{ width: "10%" }}>{ele?.tenderStatus}</div>
      </>
    );
  } else {
    return <div>Invalid listing type.</div>;
  }

  const handleDownload = async (
    id,
    userId,
    companyId,
    consumerId,
    generatorId,
  ) => {
    const payload = {
      id: id,
      companyId: companyId,
      userId: userId,
    };

    if (consumerId != null) payload.consumerId = consumerId;
    if (generatorId != null) payload.generatorId = generatorId;

    if (type === "bilateral") {
      const response = await downloadListingSuperAdmin(payload);
      const blob = response.data;
      const url = window.URL.createObjectURL(
        new Blob([blob], {
          type: "application/pdf",
        }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `listing_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      SuccessMessage("Listing downloaded successfully!");
    } else {
      const response = await getDocumentRaSuperAdmin(payload);
      const blob = response.data;
      if (!blob) return;
      const url = window.URL.createObjectURL(
        new Blob([blob], {
          type: "application/pdf",
        }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `tender_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      SuccessMessage("Listing downloaded successfully!");
    }
  };
  return (
    <>
      {viewType.status && (
        <ViewInjectDrawal
          open={viewType.status}
          handleClose={() =>
            setViewType({
              status: false,
              data: null,
            })
          }
          data={[viewType.data]}
          activeListingId={viewType.data.id}
        />
      )}

      <div className="display_flex_row tableHeading">
        {headers.map((header, index) => (
          <div key={index} style={{ width: header.width }}>
            {header.label}
          </div>
        ))}
      </div>
      {data.map((ele, index) => (
        <div key={index} className="display_flex_row tableDetails">
          {renderRow(ele)}
          <div style={{ width: "5%" }}>
            <DownloadIcon
              style={{
                cursor: "pointer",
                fontSize: "18px",
                color: "#f1935c",
              }}
              onClick={() => {
                handleDownload(
                  ele?.id,
                  ele?.userId,
                  ele?.companyId,
                  ele?.consumerId,
                  ele?.generatorId,
                );
              }}
            />
          </div>
          <div style={{ width: "5%" }}>
            <RemoveRedEyeIcon
              onClick={() =>
                (ele?.tenderStatus === "TERMS" ||
                  ele?.status === "TERMS_ACCEPTED" ||
                  ele?.status === "SCHEDULED" ||
                  ele?.status === "ONGOING") &&
                setListingView({ open: true, data: ele })
              }
              style={{
                cursor:
                  ele?.tenderStatus === "TERMS" ||
                  ele?.status === "TERMS_ACCEPTED" ||
                  ele?.status === "SCHEDULED" ||
                  ele?.status === "ONGOING"
                    ? "pointer"
                    : "no-drop",
                fontSize: "16px",
                color:
                  ele?.tenderStatus === "TERMS" ||
                  ele?.status === "TERMS_ACCEPTED" ||
                  ele?.status === "SCHEDULED" ||
                  ele?.status === "ONGOING"
                    ? "#f1935c"
                    : "#8c8a96",
              }}
            />
          </div>
        </div>
      ))}
    </>
  );
};

export default ListingTable;
